import * as types from './types';
import {
  themeActions,
  defaultCapturePhotos,
  captureFlow,
} from '~/utils/config';
import { mapDataStatus } from '~/utils/changeProgressStatus';
import { keyBy, map, merge, values } from 'lodash';

const initialState = [];

const backgroundJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHECKING_PROGRESS:
      const dataTemp = action.payload;
      const data = dataTemp.photos;
      const isVinSubmit = dataTemp.isVinSubmit;
      const result = mapDataStatus(
        data,
        isVinSubmit,
        state,
        dataTemp.options || {}
      );
      return [...result];

    case types.CHANGE_STATUS:
      return action.payload;

    case types.INITIAL_DATA_FLOW:
      let initFlow = [];
      const customFlow = action.payload.flow || [];
      switch (action.payload.theme) {
        case themeActions.PAVE_PLATE_LEFT:
          initFlow = captureFlow.plateLeft;
          break;
        case themeActions.PAVE_PLATE_RIGHT:
          initFlow = captureFlow.plateRight;
          break;
        case themeActions.PAVE_REAR_TIRE:
          initFlow = captureFlow.rearTire;
          break;
        case themeActions.PAVE_CAPT:
        case 'CUSTOM':
          initFlow = action.payload.flow;
          break;
        default:
          initFlow =
            customFlow && customFlow.length > 0
              ? customFlow
              : captureFlow.default;
          break;
      }
      console.log('DEBUG: initFlow', initFlow);
      initFlow = map(initFlow, (code, pos) => {
        return { state: pos + 1, ...defaultCapturePhotos[code] };
      });
      return values(merge(keyBy(state, 'state'), keyBy(initFlow, 'state')));
      break;

    case types.INITIAL_DISPUTE_DATA_FLOW: {
      let initFlow = [];
      const customFlow = action.payload.flow || [];
      switch (action.payload.theme) {
        case themeActions.PAVE_PLATE_LEFT:
          initFlow = captureFlow.plateLeft;
          break;
        case themeActions.PAVE_PLATE_RIGHT:
          initFlow = captureFlow.plateRight;
          break;
        case themeActions.PAVE_REAR_TIRE:
          initFlow = captureFlow.rearTire;
          break;
        case themeActions.PAVE_CAPT:
        case 'CUSTOM':
          initFlow = action.payload.flow;
          break;
        default:
          initFlow =
            customFlow && customFlow.length > 0
              ? customFlow
              : captureFlow.default;
          break;
      }

      initFlow = map(initFlow, (code, pos) => {
        return { state: pos + 1, ...defaultCapturePhotos[code] };
      });

      const disputePhoto = action.payload.disputePhoto;

      if (
        disputePhoto?.length === 0 ||
        disputePhoto === null ||
        !disputePhoto
      ) {
        return initFlow;
      }

      const disputePhotoCode = [...disputePhoto]
        .filter((v) => v.status === 'missing' || v.status === 'rejected')
        .map((v) => v.photo_code);

      const disputeFlow = initFlow
        .filter((v) => disputePhotoCode.includes(v.photoCodeUpload))
        .map((v) => {
          const photoUpload = [...disputePhoto].find(
            (disputePhoto) => disputePhoto.photo_code === v.photoCodeUpload
          );

          return {
            ...v,
            ...photoUpload,
            status: 'MISSING',
            disputePhotoStatus: photoUpload.status,
          };
        });

      return disputeFlow;
    }

    case types.UPDATE_DISPUTE_DATA_FLOW: {
      const disputePhoto = action.payload.disputePhoto;
      console.log('disputePhoto: ', disputePhoto);

      const initFlow = state;

      const disputePhotoCode = [...disputePhoto]
        .filter((v) => v.status === 'missing' || v.status === 'rejected')
        .map((v) => v.photo_code);

      const disputeFlow = initFlow.map((v) => {
        const photoUpload = [...disputePhoto].find((disputePhoto) => {
          return disputePhoto.photo_code === v.photoCodeUpload;
        });

        if (photoUpload.status === 'rejected') {
          return {
            ...v,
            ...photoUpload,
            status: 'MISSING',
            disputePhotoStatus: photoUpload.status,
          };
        } else {
          return {
            ...v,
            ...photoUpload,
            status: v.status,
            disputePhotoStatus: photoUpload.status,
          };
        }
      });

      console.log('UPDATE_DISPUTE_DATA_FLOW disputeFlow: ==> ', disputeFlow);

      return disputeFlow;
    }

    case types.RESET_CHECKING_PROGRESS:
      return initialState;

    default:
      return state;
  }
};

export default backgroundJobReducer;
